import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { BaseComponent } from '../../shared/base/base.component';
import { MatomoTracker } from 'ngx-matomo';
import { NavigationStart, Router } from "@angular/router";
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { LayoutComponent } from 'src/app/layout/layout.component';
import { TranslateService } from '@ngx-translate/core';

interface ItemData {
  sId: number;
  status: string;
  rtAmout: number;
  category: string;
  departid: string;
  pono: string;
  company: string;
  residualAmount: number;

}


interface departDatadata {
  id: string
  maintainTime: Date
  dis: string
  mDeptno: string
  cDeptno: string
  edit: boolean
  po: string
}

interface SomeSpecificType {

}


@Component({
  selector: 'app-wmsm-StatementMaintainWHQ',
  templateUrl: './wmsm-StatementMaintainWHQ.component.html',
  styleUrls: ['./wmsm-StatementMaintainWHQ.component.scss']
})
export class WmsmStatementMaintainWHQComponent extends BaseComponent implements OnInit {
  fileList: NzUploadFile[] = [];

  @Input()
  public form: any = {}
  @Output()
  private outer: EventEmitter<any> = new EventEmitter();
  @Input()
  public record: string = ''
  @Input()
  public bottomTable: any = {}

  loading: boolean = false;
  isShowCondition: boolean = true;
  // 表格每页显示条数,默认每頁顯示10筆資料
  pageSize: number = 20;
  // 表格页码
  pageIndex: number = 1;
  nzTotal: number = 0;
  validateForm: FormGroup;
  formValues: any;
  checked = false;
  indeterminate = false;
  listOfData: any[] = [];
  Approveddata: any[];
  setOfCheckedId = new Set<number>();
  isVisible = false;
  isVisible2 = false;
  inputValue?: string;
  Rejecteddata: boolean = true;
  rtSatementSendDate: any;
  Role: string;
  tw: boolean;
  cn: boolean;
  en: boolean;
  data1: string;
  rejectRemark: string;
  fixedColumn = true;
  DisabledApprovedAndRejected: boolean = false;
  listOfCurrentPageData: readonly ItemData[] = [];
  disabledrtamont: boolean = false;
  monthFormat = 'yyyy/MM';
  modaldata: any;
  ModalinvoicefilePath: string;
  ModalotherfilePath: string;
  ModalBuyerOtherFiles: string;
  DisabledDowmloadFileInvoice: boolean = false;
  DisabledDowmloadOtherFiles: boolean = false;
  DisabledDowmloadbuyerOtherFiles: boolean = false;
  disabledQuery: boolean;
  departlist: any;
  isHyperlink: boolean = false;
  Haplinkmodel: SomeSpecificType[] = [];
  modaldata2: any;
  locale: string;
  isVisible5: Boolean = false
  newdata: any
  kk: string;
  filename: string
  SelectDepartdata: any
  editCache: { [key: string]: { edit: boolean; data: departDatadata } } = {};
  departData: departDatadata[] = [];
  edit: boolean;
  noInvoiceData: boolean = false;
  constructor(
    private fb: FormBuilder,
    private AuthService: AuthService,
    private Environment: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private matomotracker: MatomoTracker,
    private router: Router,
    private http: HttpClient,
    private LayoutComponent: LayoutComponent,
    private translate: TranslateService,
  ) {

    super();
    this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe((event: NavigationStart) => {
      console.log(event.url, "event.url ")
      const urlParts = this.router.url.split('?');
      const cleanUrl = urlParts[0];
      if (event.url === '/pages/wmsm-pages/SupplierManagement/StatementPaymentManagementWHQ/wmsmStatementMaintainWHQ') {
        //  当前是列表页，且来源页是编辑页时，不刷新页面
        if (cleanUrl.indexOf("/pages/wmsm-pages/wmsmStatementMaintainWHQ-edit") !== -1) {
          this.getResultData()
        } else if (cleanUrl.indexOf("/pages/wmsm-pages/wmsmStatementMaintainWHQ-edit") == -1) {
          // 不是编辑页跳转过来的，走ngOninit
          this.ngOnInit();
          this.listOfData = [];
          this.nzTotal = 0;
        }
      }
    });
  }

  ngOnInit() {
    this.matomotracker.trackPageView("供應商管理")
    this.matomotracker.trackEvent("供應商管理", "TW对账单维护", "Transation", 1);
    this.validateForm = this.fb.group({
      haveInvoice: ['ALL'],
      PONO: [''],
      rejectRemark: [''],
      StatementMonthFrom: [''],
      StatementMonthTo: [''],
      depart: '',
      SelectDepart: ['']
    });

    this.refreshCheckedStatus
    this.checked = false
    if (this.formValues == undefined) {
      this.disabledQuery = true
    }
    this.getFormValue
    setTimeout(() => {
      this.LayoutComponent.geturl()
    }, 20);

  }

  getFormValue(value) {
    this.formValues = value;
    this.disabledQuery = false
  }

  getQuery(value) {
    this.isShowCondition = value;
  }

  onSearch() {
    this.isShowCondition = !this.isShowCondition;
    this.getResultData()

  }
  // 获取查询表格数据
  getResultData() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetRtMaintainList.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        Buyer: this.formValues.Buyer,
        siteNo: this.formValues.Site,
        VendorCode: this.formValues.Vendor,
        poNo: this.formValues.PONO,
        HaveInvoice: this.formValues.NotInvoice,
        from: this.getTheDateString_(this.formValues.StatementMonth[0]) || '',
        to: this.getTheDateString_(this.formValues.StatementMonth[1]) || '',
      },

    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (res.data.length != 0) {
          this.listOfData = res.data.filter(o => !(o.status == "Aprrove" && o.residualAmount == 0)).map((item) => {
            item.invoiceDate = DateUtil.formatYMD(item.invoiceDate);
            item.rtSatementSendDate = DateUtil.formatYMD(item.rtSatementSendDate)
            return item;
          });
          this.nzTotal = res.total;
        } else {
          this.listOfData = [];
          this.nzTotal = 0;
        }
        var value: any;
        value = this.listOfData;
        if (value == '' || value == null) {
          let language = sessionStorage.getItem("wmsmlang");
          if (language == 'zh-TW') {
            this.NzMessageService.success('該選擇條件下沒有對賬單維護信息');
          }
          if (language == 'zh-CN') {
            this.NzMessageService.success('该选择条件下没有对账单维护信息');
          }
          if (language == 'en') {
            this.NzMessageService.success('No billing maintenance information is available under this selection condition');
          }

          this.loading = false;
          return;
        }
        this.GetLanguage();
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  DownloadQueryStatementMaintainExcel() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.RemitRtStatementMatainExcel.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        Buyer: this.formValues.Buyer,
        siteNo: this.formValues.Site,
        VendorCode: this.formValues.Vendor,
        poNo: this.formValues.PONO,
        HaveInvoice: this.formValues.NotInvoice,
        from: this.getTheDateString_(this.formValues.StatementMonth[0]) || '',
        to: this.getTheDateString_(this.formValues.StatementMonth[1]) || '',
      },
    };
    this.WebApiService.doPost(url, params, true).subscribe((res) => {
      this.translate.get('DownloadSuccessfully').subscribe((translatedText: string) => {
        this.NzMessageService.success(translatedText);
      })
      this.downloadFile8(res, `TWN_Payment_Maintain_${this.getTimeString()}.xlsx`);
      this.loading = false;
    });
  }


  //切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.getResultData();
  }
  //切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    this.getResultData();
  }
  RnoOnClick(value) {
    console.log(value)
    this.router.navigate(["/pages/wmsm-pages/wmsmStatementMaintainWHQ-edit"], {
      queryParams: { pono: value.pono, currency: value.currency, company: value.company, invoice: value.invoice, index: 0, DisabledManualInvoice: true, SiteNo: value.siteNo, headId: value.paHeadId }, skipLocationChange: true
    });
  }



  showmodal(): void {
    this.isVisible = true;
  }

  showmodal2(value): void {
    this.loading = true;
    var arr = new Array();
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetPolnDetailList.url}`;
    const params = {
      data:
      {
        headId: value.paHeadId,
        siteNo: value.siteNo,
        poNo: value.pono,
      }
    };
    this.WebApiService.doPost(url, params).toPromise().then((res) => {
      if (!res.invoicesList || res.invoicesList.length === 0) {
        this.noInvoiceData = true;
        this.modaldata2 = [];
        this.loading = false;
        this.translate.get('NoUnsubmittedPaymentData').subscribe((translatedText: string) => {
          this.NzMessageService.warning(translatedText);
        }); return;
      } else {
        this.noInvoiceData = false;
        this.isVisible2 = true;
        this.modaldata = value;
        arr.push(res.invoicesList);
        arr[0].forEach(item => {
          item.currency = value.currency;
        });
        this.modaldata2 = arr[0].filter(item => {
          this.loading = false;
          return item;
        });
      }
      this.loading = false;
    })
  }


  showHyperlink(value): void {
    debugger
    this.Haplinkmodel = []
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetHyperlinkList.url}`;
    const params = {
      data: {
        supplierCode: value.vendorCode,
        siteNo: value.siteNo,
        poNo: value.pono
      },
    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        var rsedata = res.data.data;
        if (rsedata.length == 0) {
          this.isHyperlink = false;
          this.translate.get('TheInvoiceHasNoHyperlink').subscribe((translatedText: string) => {
            this.NzMessageService.warning(translatedText);
          })
        } else {
          this.isHyperlink = true;
          this.Haplinkmodel.push(...rsedata);
        }

      })

  }


  //详情键下载发票文件
  DowmloadFile(filetoken, FileName) {
    this.WebApiService.downloadFileByToken(filetoken).subscribe(
      (res) => {
        debugger
        this.downloadFile8(res, FileName);
        this.NzMessageService.success(res.msg);
      },
      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );
  }

  //详情键下载附件
  DowmloadOtherFiles(filetoken, FileName) {
    this.WebApiService.downloadFileByToken(filetoken).subscribe(
      (res) => {
        debugger
        this.downloadFile8(res, FileName);
        this.NzMessageService.success(res.msg);
      },

      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );

  }

  //详情键采购下载附件
  DowmloadBuyerOtherFiles(filetoken, FileName) {
    this.WebApiService.downloadFileByToken(filetoken).subscribe(
      (res) => {
        this.downloadFile8(res, FileName);
        this.NzMessageService.success(res.msg);
      },

      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );

  }

  handleOk(): void {
    this.isVisible = false;
    this.data1 = "1"
    this.rejectRemark = this.inputValue
    this.ApprovedAndRejected()
    this.setOfCheckedId.clear();
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  handleOk2(): void {
    this.isVisible2 = false;
    this.setOfCheckedId.clear();
  }



  handleCancel2(): void {
    this.isVisible2 = false;
  }



  handleOk4(): void {
    this.isHyperlink = false;
  }

  handleCancel4(): void {
    this.isHyperlink = false;
  }


  handleOk5(): void {
    this.isVisible5 = false;
  }

  handleCancel5(): void {
    this.isVisible5 = false;
  }

  sortChange(e) {
    this.listOfData = e === 'ascend' ? this.listOfData.sort(
      (a, b) => a.pono.localeCompare(b.pono)
    ) : this.listOfData.sort(
      (a, b) => b.pono.localeCompare(a.pono)
    )
  }

  sortChange1(e) {
    this.listOfData = e === 'ascend' ? this.listOfData.sort(
      (a, b) => a.invoice.localeCompare(b.invoice)
    ) : this.listOfData.sort(
      (a, b) => b.invoice.localeCompare(a.invoice)
    )
  }

  myChange(e) {
    // this.bottomTable.pageNo = e
    this.outer.emit(e)
  }

  GetLanguage() {
    if (sessionStorage.getItem("wmsmlang") == "zh-CN") {
      this.cn = true;
      this.tw = false;
      this.en = false;
    }
    if (sessionStorage.getItem("wmsmlang") == "zh-TW") {
      this.tw = true;
      this.cn = false;
      this.en = false;
    }
    if (sessionStorage.getItem("wmsmlang") == "en") {
      this.en = true;
      this.cn = false;
      this.tw = false;
    }

  }


  updateCheckedSet(sId: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(sId);
      this.departData = []
    } else {
      this.setOfCheckedId.delete(sId);
      //  this.listdata;
    }
  }

  onItemChecked(sId: number, checked: boolean): void {
    this.updateCheckedSet(sId, checked);
    if ((this.listOfCurrentPageData.find(o => o.sId == sId).residualAmount == 0 && (this.listOfCurrentPageData.find(o => o.sId == sId).category == null || this.listOfCurrentPageData.find(o => o.sId == sId).category == "P" || this.listOfCurrentPageData.find(o => o.sId == sId).category == "")) && checked == true) {
      this.disabledrtamont = true;
      this.translate.get('RT/ACAmountIsZero').subscribe((translatedText: string) => {
        this.NzMessageService.warning(translatedText);
      })
    }
    if ((this.listOfCurrentPageData.find(o => o.sId == sId).residualAmount == 0 && (this.listOfCurrentPageData.find(o => o.sId == sId).category == null || this.listOfCurrentPageData.find(o => o.sId == sId).category == "P" || this.listOfCurrentPageData.find(o => o.sId == sId).category == "")) && checked == false) {
      this.disabledrtamont = false;
    }
    this.refreshCheckedStatus();
  }

  onAllChecked(checked: boolean): void {
    this.listOfCurrentPageData.forEach(item => {
      if (item.status == "Ongoing") {
        this.updateCheckedSet(item.sId, checked)
      }
      if ((item.residualAmount == 0 && (item.category == null || item.category == "P" || item.category == "")) && checked == true && item.status == "Ongoing") {
        this.disabledrtamont = true;
        this.translate.get('RT/ACAmountIsZero').subscribe((translatedText: string) => {
          this.NzMessageService.warning(translatedText);
        })
      }
      if ((item.residualAmount == 0 && (item.category == null || item.category == "P" || item.category == "")) && checked == false) {
        this.disabledrtamont = false;
      }
    }
    );
    this.refreshCheckedStatus();
  }

  onCurrentPageDataChange($event: readonly ItemData[]): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(item => this.setOfCheckedId.has(item.sId));
    this.indeterminate = this.listOfCurrentPageData.some(item => this.setOfCheckedId.has(item.sId)) && !this.checked;
  }



  clickApproved() {
    this.data1 = "0"
    this.ApprovedAndRejected()
    this.setOfCheckedId.clear();
  }



  Changedept(data) {
    this.loading = true;
    this.departlist = data
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetPrListByPO.url}?po=` + data.pono;
    this.WebApiService.doPost(url, data.pono).subscribe(
      (res) => {
        this.departData = res.data.map((item) => {
          item.maintainTime = DateUtil.formatYMD(item.maintainTime);
          this.loading = false;
          return item;
        });
        this.updateEditCache()
        this.isVisible5 = true;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
  }


  //手动更改时搜索要变更的部门
  ChangeselectDepart(value) {
    if (value.length > 2) {
      this.loading = true;
      const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.ChangeDeptList.url}`;
      const req = {
        data: {
          aNo: "",
          acNo: "",
          deptCode: "",
          deptKind: "",
          searchStr: value,
          siteNo: "",
          sort: 0,
        }

      };
      this.WebApiService.doPost(url, req).subscribe(
        (res) => {
          this.SelectDepartdata = res.data.data
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
    } else {
      this.SelectDepartdata = []
    }
  }



  // ApprovedAndRejected
  ApprovedAndRejected() {
    var data = [];
    this.setOfCheckedId.forEach(x => {
      var dto = this.listOfData.find(o => o.sId == x);
      data.push(dto);
    })
    //.forEach()
    this.loading = true
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.WHQPoSignoff.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        list: data,
        button: this.data1,
        rejectRemark: this.rejectRemark,
      }
    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (data.length !== 0 && this.data1 == "0") {
          let language = sessionStorage.getItem("wmsmlang");
          if (language == 'zh-TW') {
            this.NzMessageService.success(res.msg);
          }
          if (language == 'zh-CN') {
            this.NzMessageService.success(res.msg);
          }
          if (language == 'en') {
            this.NzMessageService.success(res.msg);
          }
          if (res.status == 200) {
            this.getResultData();
          }
          this.loading = false;
          return;
        }
        if (data.length == 1 && this.data1 == "1") {
          let language = sessionStorage.getItem("wmsmlang");
          if (language == 'zh-TW') {
            this.NzMessageService.success('成功');
          }
          if (language == 'zh-CN') {
            this.NzMessageService.success('成功');
          }
          if (language == 'en') {
            this.NzMessageService.success('succeed');
          }
          if (res.status == 200) {
            this.getResultData();
          }
          this.loading = false;
          return;
        }
        if (data.length > 1 && this.data1 == "1") {
          let language = sessionStorage.getItem("wmsmlang");
          if (language == 'zh-TW') {
            this.NzMessageService.warning('只能選擇一條數據');
          }
          if (language == 'zh-CN') {
            this.NzMessageService.warning('只能选择一条数据');
          }
          if (language == 'en') {
            this.NzMessageService.warning('Only one piece of data can be selected');
          }
          this.loading = false;
          return;
        }

        if (data.length == 0) {
          let language = sessionStorage.getItem("wmsmlang");
          if (language == 'zh-TW') {
            this.NzMessageService.warning('請選擇數據');
          }
          if (language == 'zh-CN') {
            this.NzMessageService.warning('请选择数据');
          }
          if (language == 'en') {
            this.NzMessageService.warning('Please select data');
          }
          this.loading = false;
          return;
        }
        this.loading = false
      },
      (error) => {
        this.NzMessageService.error(error.msg);
        this.loading = false
      }
    );



  }

  confirm(data): void {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.Revocation.url}`;
    const params = {
      data:
      {
        PoNo: data.pono,
        InvoiceNo: data.invoice
      }
    };
    this.WebApiService.doPost(url, params,).subscribe(
      (res) => {
        this.getResultData()
        this.NzMessageService.success(res.msg);
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
  }
  //千分位
  addThousandSeprator = (strOrNum) => {
    return parseFloat(strOrNum).toFixed(2).toString().split('.').map((x, idx) => {
      if (!idx) {
        return x.split('')
          .reverse()
          .map((xx, idxx) => (idxx && !(idxx % 3)) ? (xx + ',') : xx)
          .reverse()
          .join('')
      } else {
        return x;
      }
    }).join('.')
  }

  beforeBuyerOtherFiles = (file: NzUploadFile) => {
    this.UploadBuyerOtherFiles(file);
  }

  UploadBuyerOtherFiles(file) {
    this.filename = file.name
    var pono = this.modaldata2[0].pono
    var invoice = this.modaldata2[0].invoice;
    this.loading = true;
    const formData = new FormData();
    formData.append('id', this.modaldata2[0].maintianId);
    formData.append('purpose', 'BuyerOtherFiles');
    formData.append('file', file);
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UploadBuyerOtherFiles.url}?PoNo=` + pono + '&Invoice=' + invoice;
    const _headers = new HttpHeaders();
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    }); this.http.request(req).pipe(filter((e) => e instanceof HttpResponse)).subscribe(
      (res) => {

        if (res['body'].status == 200) {
          this.translate.get('UploadSuccess').subscribe((translatedText: string) => {
            this.NzMessageService.success(translatedText);
          })
          this.getnewdata(this.modaldata2[0].maintianId)
          this.getResultData();
          this.loading = false;

        }
        else {
          this.translate.get('FailToDelete').subscribe((translatedText: string) => {
            this.NzMessageService.error(translatedText);
          })
        }
        this.loading = false;
      },
      (error) => {
        this.translate.get('UploadFailed').subscribe((translatedText: string) => {
          this.NzMessageService.error(translatedText);
        })
        this.loading = false;
      }
    );


  }

  //获取更新后的数据
  getnewdata(value) {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.QueryNewData.url}?id=` + value;
    const params = {
    };
    this.WebApiService.doPost(url, params,).subscribe(
      (res) => {
        var ff = res.data
        this.showmodal2(ff)
      },
      (error) => {
        this.loading = false;
      }
    );
  }



  startEdit(id: string): void {
    this.editCache[id].edit = true;
  }

  cancelEdit(id: string): void {
    const index = this.departData.findIndex(item => item.id === id);
    this.editCache[id] = {
      data: { ...this.departData[index] },
      edit: false
    };
  }

  saveEdit(id: string): void {
    var changeDept = this.editCache[id].data.mDeptno
    const index = this.departData.findIndex(item => item.id === id);
    Object.assign(this.departData[index], this.editCache[id].data);
    this.editCache[id].edit = false;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.ChangePrDept.url}?id=` + id + '&changeDept=' + changeDept;;
    const params = {
    };
    this.WebApiService.doPost(url, params,).subscribe(
      (res) => {
        //重新更新该modal
        const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetPrListByPO.url}?po=` + this.editCache[id].data.po;
        this.WebApiService.doPost(url, this.editCache[id].data.po).subscribe(
          (res) => {
            this.departData = res.data.map((item) => {
              item.maintainTime = DateUtil.formatYMD(item.maintainTime);
              this.loading = false;
              return item;
            });
            this.updateEditCache()
            this.isVisible5 = true;
            this.loading = false;
          },
          (error) => {
            this.loading = false;
          }
        );
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  updateEditCache(): void {
    this.departData.forEach(item => {
      this.editCache[item.id] = {
        edit: false,
        data: { ...item }
      };
    });
  }


  onQueryClick1(): string {
    return 'StatementMaintainWHQ';
  }
}
